import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { useParams, Link, useNavigate } from "react-router-dom";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import EditTermApplicantNoteDialog from "./EditTermApplicantNoteDialog";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_ALL_APPLICANTS_BY_TERM_ID_QUERY } from "../../graphQL/term_applicant_qry";
import {
  GET_TERM_DATA_BY_TERM_UUID,
  UPDATE_NO_OF_SEATS_MUTATION,
} from "../../graphQL/term_qry";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import { Tabs, Tab } from "@mui/material";
import styled from "styled-components";
import penImg from "../../assets/icons/pen.png";

import Header from "../terms/Header.js";
import ApplicantsDetail from "./applicantsDetail.js";
import ApplicantsOneOnOne from "./applicantsOneOnOne.js";
import AlertDialog from "../../components/AlertDialog.js";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SelectQualifiedApplicantsDialog from "./selectQualifiedApplicantsDialog.js";
import SelectUnQualifiedApplicantsDialog from "./selectUnQualifiedApplicantsDialog.js";
import ApplicantInfoDialog from "./applicantInfoDialog.js";
import EditApplicantFeedbackDialog from "./EditApplicantFeedbackDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`

  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap; 
    max-width: none;

  }
 
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
      textAlign: "center",
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
      {
        outline: "none !important",
      },
    "&.MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.green`]: {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.green:hover`]: {
      backgroundColor: "#EFFFCA",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E3F2FD !important",
    },
    [`& .${gridClasses.row}.green.Mui-selected`]: {
      backgroundColor: "#EFFFCA !important",
    },
  },
  dataGridFooterStyle: {
    height: 80,
    marginBottom: 0,
    backgroundColor: "#99D4FF",
    display: "flex",
    alignItems: "center",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 18,
    fontWeight: 700,
    // marginLeft: 10,
  },
  textFieldStyle: {
    // height: 55,
    // marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      height: 45,
      borderRadius: 10,
      fontSize: 16,
    },
  },
  noOfSeatsBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px",
  },
  noOfSeatsTextStyle: {
    width: 60,
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 16,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    paddingLeft: 10,
    alignItems: "center",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },

  applicantTabs: {
    borderBottom: "1px solid #ddd",
    paddingRight: 50,
    paddingTop: 30,
    "& .MuiSvgIcon-root": {
      fontSize: "30px",
      "&:hover": {
        backgroundColor: "#1E88E5",
        color: "#fff",
        border: "none",
        borderRadius: "100%",
      },
    },
  },
  tabs: {
    color: "#000000de",
    "&.Mui-selected": {
      color: "#0D47A1",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },
}));

function ApplicantsBoard() {
  const { termUuid } = useParams();
  const [termName, setTermName] = useState("");
  const [termLink, setTermLink] = useState(null);
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [numExpandedRow, setNumExpandedRow] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);
  const [noOfSeats, setNoOfSeats] = useState(1);
  const [editedNoOfSeats, setEditedNoOfSeats] = useState(1);
  const [qualAppsList, setQualAppsList] = useState([]);
  const [openSelQualDlg, setOpenSelQualDlg] = useState(false);
  const [openApplicantInfoDlg, setOpenApplicantInfoDlg] = useState(false);
  const [openSelUnQualDlg, setOpenSelUnQualDlg] = useState(false);
  const [editingNoOfSeats, setEditingNoOfSeats] = useState(false);
  const [disableNoOfSeats, setDisableNoOfSeats] = useState(false);
  const [focusNoOfSeats, setFocusNoOfSeats] = useState(false);
  const [termInfo, setTermInfo] = useState("");
  const [errorMsg, setErrorMsg] = useState({ noOfSeats: "", applicantSelection: "" });
  const [applicantsList, setApplicantsList] = useState([]);
  const [acceptedApplicantsList, setAcceptedApplicantsList] = useState([]);
  const [unQualApplicantsList, setUnQualApplicantsList] = useState([]);
  const [quesList, setQuesList] = useState([]);
  const [updateScores, setUpdateScores] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [openEditTermApplicantNoteDialog, setOpenEditTermApplicantNoteDialog] =
    useState(false);
  const [currentApplicantData, setCurrentApplicantData] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [selectedApplicant, setSelectedApplicant] = useState("");
  const [selectedTermApplicant, setSelectedTermApplicant] = useState("");
  const [selectedApplicantDateApplied, setSelectedApplicantDateApplied] = useState("");
  const [openEditApplicantFeedbackDialog, setOpenEditApplicantFeedbackDialog] =
    useState(false);

  const [fetchTermApplicants] = useManualQuery(GET_ALL_APPLICANTS_BY_TERM_ID_QUERY, {
    fetchPolicy: "network-only",
  });

  const [getTermInfo] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID, {
    fetchPolicy: "network-only",
  });

  const [updateNoOfSeats] = useMutation(UPDATE_NO_OF_SEATS_MUTATION);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });

  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    let qualList = [];
    applicantsList.map((app, index) => {
      if (index < noOfSeats) qualList.push(app);
    });
    setQualAppsList(qualList);
  }, [noOfSeats, applicantsList]);

  useEffect(() => {
    let acceptedList = [];
    applicantsList.map((app, index) => {
      if (app.applicationAccepted) acceptedList.push(app);
    });
    setAcceptedApplicantsList(acceptedList);
  }, [applicantsList]);

  useEffect(() => {
    let rejectedList = [];
    applicantsList.map((app, index) => {
      if (app.applicationAccepted == false) rejectedList.push(app);
    });
    setUnQualApplicantsList(rejectedList);
  }, [applicantsList]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat =
      format !== null
        ? formatter1.formatToParts(dayDate)
        : formatter2.formatToParts(dayDate);
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find(a => a.type == "weekday").value +
        ", " +
        dayFormat.find(a => a.type == "day").value +
        " " +
        dayFormat.find(a => a.type == "month").value +
        ", " +
        dayFormat.find(a => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find(a => a.type == "month").value +
        " " +
        dayFormat.find(a => a.type == "day").value +
        ", " +
        dayFormat.find(a => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD") {
      const newFormat =
        dayFormat.find(a => a.type == "weekday").value +
        ", " +
        dayFormat.find(a => a.type == "year").value +
        ", " +
        dayFormat.find(a => a.type == "month").value +
        " " +
        dayFormat.find(a => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
      return newFormat;
    }
  };

  const InfoCell = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <>
        <StyledTooltip title="More info" placement="bottom">
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
            }}
          >
            <MoreHorizIcon
              style={{ cursor: "pointer", marginTop: 10 }}
              onClick={handleOpen}
            />
          </span>
        </StyledTooltip>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem
            onClick={() => {
              handleApplicantInfoClick(row);
              handleClose();
            }}
          >
            Applicant Info
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleApplicantFeedbackClick(row);
              handleClose();
            }}
          >
            Staff Feedback
          </MenuItem>
        </Menu>
      </>
    );
  };

  const sortApplicants = data => {
    let updatedAppList = findAnd.changeProps(
      applicantsList,
      { termApplicantId: data.termApplicantId },
      {
        totalAwardedScore: data.totalAwardedScore,
      },
    );
    updatedAppList.sort((a, b) =>
      parseInt(a.totalAwardedScore) < parseInt(b.totalAwardedScore) ? 1 : -1,
    );
    setApplicantsList(updatedAppList);
  };

  const saveNoOfSeats = async newVal => {
    const { data, error } = await updateNoOfSeats({
      variables: {
        termId: parseInt(termInfo.termId),
        noOfSeats: parseInt(newVal),
      },
    });
    if (error) {
      console.log("Error", error, data);
    } else {
      console.log("Success in saving term no of seats", data.updateNoOfSeats);
    }
  };

  const getTermApplicants = async () => {
    setCheckList([]);
    if (termUuid) {
      // Get term information
      const {
        loading: termInfoLoading,
        error: termInfoError,
        data: termInfo,
      } = await getTermInfo({
        variables: { termUuid: termUuid },
      });

      if (!termInfoLoading && termInfo && termInfo.getTermDataByTermUuid) {
        setTermInfo(termInfo.getTermDataByTermUuid);
        setTermName(termInfo.getTermDataByTermUuid.name);
        setEditedNoOfSeats(termInfo.getTermDataByTermUuid.noOfSeats);
        setNoOfSeats(termInfo.getTermDataByTermUuid.noOfSeats);

        setDisableNoOfSeats(termInfo.getTermDataByTermUuid.notifyAll);
        // if(!termInfo.getTermDataByTermUuid.urlActivated)
        setTermLink(`${project_url}/terms/${termUuid}`);
        // Get term applicants information
        const {
          loading: termApplicantsLoading,
          error: termApplicantsError,
          data: termApplicantsData,
        } = await fetchTermApplicants({
          variables: {
            termId: parseInt(termInfo.getTermDataByTermUuid.termId),
          },
        });

        if (
          !termApplicantsLoading &&
          termApplicantsData &&
          termApplicantsData.getAllApplicantsByTermId
        ) {
          // Sorting rows data by total assigned score
          //termApplicantsData.getAllApplicantsByTermId.sort((a,b) =>
          //  parseInt(a.totalAwardedScore) < parseInt(b.totalAwardedScore) ? 1 : -1);

          //Adding expanded flag to every item of ApplicantsList
          const updApplicantsList = termApplicantsData.getAllApplicantsByTermId.map(
            (entry, index) => ({ ...entry, expanded: false, id: index + 1 }),
          );
          const filteredApplicants = updApplicantsList.filter(
            applicant => applicant.applicantId.viaForm === true,
          );
          setApplicantsList(filteredApplicants);
        }
        if (
          termApplicantsError &&
          termApplicantsError.graphQLErrors &&
          termApplicantsError.graphQLErrors[0].message === "Signature has expired"
        ) {
          navigate(`${project_url}/signin`);
        }
      }
      if (
        termInfoError &&
        termInfoError.graphQLErrors &&
        termInfoError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }

      if (
        termInfoError &&
        termInfoError.graphQLErrors &&
        termInfoError.graphQLErrors[0].message === "Term matching query does not exist."
      ) {
        alert("Are you sure you have valid URL?");
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  useEffect(() => {
    (() => getTermApplicants())();
  }, [termUuid]);

  const classes = useStyles();
  const validateNoOfSeats = value => {
    if (parseInt(value) < 1) {
      setErrorMsg({ noOfSeats: "Enter an integer greater than zero." });
    } else if (parseInt(value) > 99) {
      setErrorMsg({ noOfSeats: "Enter an integer less than 99." });
    } else if (value.toString().trim() === "") {
      setErrorMsg({ noOfSeats: "No of Seats cannot be blank." });
    } else {
      setErrorMsg({});
    }
    setEditedNoOfSeats(value);
  };

  const handleApplicantTabChange = (event, newValue) => {
    if (newValue == 1) getTermApplicants();

    setSelectedTab(newValue);
  };

  const handleChangeExpandStatus = async id => {
    let foundRow = findAnd.returnFound(applicantsList, {
      id: id,
    });
    let expandedRowCounter = 0;
    await applicantsList.map(app => {
      if (app.expanded) expandedRowCounter += 1;
    });
    // Check number of expanded rows
    if (expandedRowCounter === 0)
      if (!foundRow.expanded) setNumExpandedRow(1);
      else setNumExpandedRow(0);

    if (expandedRowCounter === 1)
      if (!foundRow.expanded) setNumExpandedRow(2);
      else setNumExpandedRow(0);

    if (expandedRowCounter > 1)
      if (!foundRow.expanded) return;
      else setNumExpandedRow(1);
    /////
    let appsList = findAnd.changeProps(
      applicantsList,
      { id: id },
      {
        expanded: foundRow ? !foundRow.expanded : false,
      },
    );
    var index = expandedRows.findIndex(item => item.id === foundRow.id);
    let draftExpandedRows = update(
      expandedRows,
      index === -1 ? { $push: [foundRow] } : { $splice: [[index, 1]] },
    );
    setExpandedRows(draftExpandedRows);
    setApplicantsList(appsList);
  };

  const handleCheckBoxChange = (event, row) => {
    const isChecked = event.target.checked;
    const { termApplicantId, applicantName } = row;
    setErrorMsg({ applicantSelection: "" });

    setCheckList(prev => {
      if (isChecked) {
        // add if not already in the list
        if (!prev.some(item => item.termApplicantId === termApplicantId)) {
          return [...prev, { termApplicantId, applicantName }];
        }
        return prev;
      } else {
        // remove if unchecked
        return prev.filter(item => item.termApplicantId !== termApplicantId);
      }
    });
  };

  const handleApplicantFeedbackClick = row => {
    setSelectedTermApplicant(row.termApplicant);
    setOpenEditApplicantFeedbackDialog(true);
  };

  const handleApplicantInfoClick = row => {
    setSelectedApplicant(row.applicant);
    setSelectedApplicantDateApplied(row.dateApplied);
    setOpenApplicantInfoDlg(true);
  };

  const handlePromoteClick = () => {
    if (checkList.length > 0) {
      setOpenSelUnQualDlg(true);
    } else {
      setErrorMsg({ applicantSelection: "Please select one applicant at least" });
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "",
      headerClassName: "super-app-theme--header",
      width: 5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: rows => {
        return !rows.row.expanded ? (
          <StyledTooltip title="Click to view application" placement="bottom">
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
              }}
            >
              <ArrowRightIcon
                color={numExpandedRow === 2 && !rows.row.expanded ? "disabled" : "action"}
                style={{
                  cursor: numExpandedRow === 2 && !rows.row.expanded ? "" : "pointer",
                  paddingTop: 5,
                  height: 40,
                  width: 40,
                }}
                onClick={() => handleChangeExpandStatus(rows.row.id)}
              />
            </span>
          </StyledTooltip>
        ) : (
          <StyledTooltip title="Click to close application" placement="bottom">
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
              }}
            >
              <ArrowDropDownIcon
                color="primary" //sx={{color:"#0D47A1"}}
                style={{ cursor: "pointer", height: 40, width: 40, paddingTop: 5 }}
                onClick={() => handleChangeExpandStatus(rows.row.id)}
              />
            </span>
          </StyledTooltip>
        );
      },
    },
    {
      field: "info",
      headerName: "",
      headerClassName: "super-app-theme--header",
      width: 3,
      sortable: false,
      disableColumnMenu: true,
      renderCell: rows => <InfoCell row={rows.row} />,
    },
    {
      field: "feedback",
      headerName: "",
      headerClassName: "super-app-theme--header",
      width: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: rows => {
        const feedback = rows.row.termApplicant?.feedbackOverall;

        const getColor = () => {
          switch (feedback?.trim()) {
            case "Acceptable":
              return "#4caf50"; // green
            case "Possible":
              return "#ff9800"; // orange
            case "Review":
              return "#f44336"; // red
            default:
              return "#9e9e9e"; // fallback (gray)
          }
        };

        return (
          <Box display="flex" alignItems="center">
            {/* Indicator */}
            <StyledTooltip title={feedback} placement="bottom">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                }}
              >
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: getColor(),
                    marginRight: 1,
                    marginTop: 1.5,
                  }}
                />
              </span>
            </StyledTooltip>
          </Box>
        );
      },
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      headerClassName: "super-app-theme--header",
      minWidth: 50,
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 0.7,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "assignedScore",
      headerClassName: "super-app-theme--header",
      headerName: "Assigned Score",
      minWidth: 20,
      flex: 0.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "dateApplied",
      headerClassName: "super-app-theme--header",
      headerName: "Date Applied",
      minWidth: 30,
      flex: 0.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "pastApplication",
      headerClassName: "super-app-theme--header",
      headerName: "Applicant Status",
      minWidth: 50,
      flex: 0.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "awardedScore",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 20,
      flex: 0.5,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];

  const optColumns = [
    {
      field: "applicantName",
      headerName: "Applicant Name",
      headerClassName: "super-app-theme--header",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "awardedScore",
      headerName: "Awarded Score",
      headerClassName: "super-app-theme--header",
      width: 20,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      width: 20,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "OptInOutDecision",
      headerName: "Opt In/Out",
      headerClassName: "super-app-theme--header",
      width: 20,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "note",
      headerName: "Note",
      headerClassName: "super-app-theme--header",
      width: 180,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      headerClassName: "super-app-theme--header",
      width: 180,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "action",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <StyledTooltip title="Update applicant opt in/out">
            <img
              style={{
                paddingRight: 10,
                paddingTop: 6,
                height: 24,
                weight: 24,
                cursor: "pointer",
              }}
              src={penImg}
              onClick={() => {
                setCurrentApplicantData(rows.row);
                setOpenEditTermApplicantNoteDialog(true);
              }}
            />
          </StyledTooltip>
        );
      },
    },
  ];

  const rejectedColumns = [
    {
      field: "select",
      headerName: "Select",
      headerClassName: "super-app-theme--header",
      width: 90,
      sortable: false,
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <Checkbox
            checked={checkList.some(
              item => item.termApplicantId === rows.row.termApplicantId,
            )}
            onChange={e => handleCheckBoxChange(e, rows.row)}
          />
        );
      },
    },

    {
      field: "applicantName",
      headerName: "Applicant Name",
      headerClassName: "super-app-theme--header",
      width: 300,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "awardedScore",
      headerName: "Awarded Score",
      headerClassName: "super-app-theme--header",
      width: 250,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      width: 250,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "notificationDate",
      headerName: "Rejection Email Notification Date",
      headerClassName: "super-app-theme--header",
      width: 380,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
    },
  ];

  const rows = applicantsList.map((app, index) => ({
    index,
    id: app.id,
    applicantName:
      app.applicantId.userId.firstName + " " + app.applicantId.userId.lastName,
    email: app.applicantId.userId.email,
    assignedScore: app.totalAssignedScore,
    dateApplied: dayFormat(app.applicantId.createDate.substring(0, 10)),
    pastApplication: app.applicantStatus,
    awardedScore: app.totalAwardedScore,
    expanded: app.expanded,
    applicant: app.applicantId.userId,
    termApplicant: app,
  }));

  const optRows = acceptedApplicantsList.map((app, index) => ({
    index,
    id: app.id,
    termApplicantId: app.termApplicantId,
    applicantName:
      app.applicantId.userId.firstName + " " + app.applicantId.userId.lastName,
    awardedScore: app.totalAwardedScore,
    status: app.applicantStatus,
    OptInOutDecision: app.optInOutDecision ? "In" : "Out",
    note: app.note,
    lastUpdated: dayFormat(app.updateDate.substring(0, 10)),
  }));

  const rejectedRows = unQualApplicantsList.map((app, index) => ({
    index,
    id: app.id,
    termApplicantId: app.termApplicantId,
    applicantName:
      app.applicantId.userId.firstName + " " + app.applicantId.userId.lastName,
    awardedScore: app.totalAwardedScore,
    status: app.applicantStatus,
    notificationDate: app.applicantNotifiedDate
      ? dayFormat(app.applicantNotifiedDate.substring(0, 10))
      : "",
  }));

  const customFooter = () => {
    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={3}>
          <Typography
            className={classes.dataGridFooterTextStyle}
            style={{ marginLeft: 10 }}
          >
            Total No of Applicants
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography className={classes.dataGridFooterTextStyle}>
            {applicantsList.length}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  if (loadContent)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: termName, link: termLink },
            { label: "Applicants", link: null },
          ]}
        />

        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Applicants
            </Typography>
          </Box>
          <Divider />

          <Box
            pt={2}
            style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Term Name:
            </Typography>
            {termInfo && <Typography variant="h3">{termInfo.name}</Typography>}
          </Box>

          <Box
            pt={2}
            style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Term Period:
            </Typography>
            {termInfo.startDate && termInfo.endDate && (
              <Typography variant="h3">
                {dayFormat(termInfo.startDate.substring(0, 10), "monthDDYYYY")} -{" "}
                {dayFormat(termInfo.endDate.substring(0, 10), "monthDDYYYY")}
              </Typography>
            )}
          </Box>

          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              paddingTop: editingNoOfSeats ? 0 : 10,
            }}
          >
            <Typography
              variant="h2"
              style={{
                paddingRight: 10,
                paddingTop: editingNoOfSeats ? 10 : 0,
              }}
            >
              No of Available Seats:
            </Typography>
            {disableNoOfSeats ? (
              <Box className={classes.noOfSeatsBoxStyle}>
                <Typography variant="h3">{editedNoOfSeats}</Typography>
                <StyledTooltip
                  placement="bottom"
                  title="No of Seats cannot be editted as notification emails have been sent to applicants"
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 40,
                      height: 25,
                    }}
                  >
                    <IconButton style={{ cursor: "auto" }}>
                      <EditOutlinedIcon
                        style={{ cursor: "auto", filter: "grayscale(1)", opacity: 0.5 }}
                      />
                    </IconButton>
                  </span>
                </StyledTooltip>
              </Box>
            ) : (
              <>
                {!editingNoOfSeats ? (
                  <Box className={classes.noOfSeatsBoxStyle}>
                    <Typography
                      variant="h1"
                      className={classes.noOfSeatsTextStyle}
                      onClick={() => {
                        setEditingNoOfSeats(true);
                        setFocusNoOfSeats(true);
                      }}
                    >
                      {editedNoOfSeats}
                    </Typography>
                    <IconButton>
                      <EditOutlinedIcon
                        onClick={() => {
                          setEditingNoOfSeats(true);
                          setFocusNoOfSeats(true);
                        }}
                      />
                    </IconButton>
                  </Box>
                ) : (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "start",
                      alignItems: "center",
                      paddingTop: 12,
                    }}
                  >
                    <TextField
                      className={classes.textFieldStyle}
                      id="outlined-multiline-static"
                      variant="outlined"
                      type="number"
                      value={editedNoOfSeats}
                      variant="outlined"
                      onKeyDown={e => {
                        if (e.key === "Enter") {
                          if (!errorMsg.noOfSeats) {
                            setNoOfSeats(editedNoOfSeats);
                            setEditingNoOfSeats(false);
                          }
                        }
                        if (e?.key === "-" || e?.key === "+") {
                          e.preventDefault();
                        }
                        if (e.keyCode >= 65 && e.keyCode <= 90) {
                          e.preventDefault();
                        }
                      }}
                      onChange={e => validateNoOfSeats(e.target.value)}
                      InputProps={{
                        inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                      }}
                      id="noOfSeats"
                      error={errorMsg.noOfSeats}
                    />
                    <Box
                      className={classes.iconStyle}
                      onClick={() => {
                        if (!errorMsg.noOfSeats) {
                          setNoOfSeats(editedNoOfSeats);
                          setEditingNoOfSeats(false);
                          saveNoOfSeats(editedNoOfSeats);
                        }
                      }}
                    >
                      <CheckIcon sx={{ color: "gray", cursor: "pointer" }} />
                    </Box>
                    <Box
                      className={classes.iconStyle}
                      style={{ marginLeft: 7 }}
                      onClick={() => {
                        setEditingNoOfSeats(false);
                        setEditedNoOfSeats(noOfSeats);
                        setErrorMsg({});
                      }}
                    >
                      <CloseIcon sx={{ color: "gray", cursor: "pointer" }} />
                    </Box>
                    {errorMsg.noOfSeats && (
                      <Box ml={2}>
                        <FormHelperText className={classes.errorStyle} error>
                          {errorMsg.noOfSeats}
                        </FormHelperText>
                      </Box>
                    )}
                  </Box>
                )}
              </>
            )}
          </Grid>

          <Grid container alignItems="center">
            <Grid item xs={12}>
              <Tabs
                value={selectedTab}
                onChange={handleApplicantTabChange}
                variant="scrollable"
                scrollButtons="auto"
                className={classes.applicantTabs}
              >
                {[
                  " Applicants Qualification ",
                  " Applicants Opt in/out ",
                  " Applicants Adjustment ",
                ].map((item, index) => (
                  <Tab
                    className={classes.tabs}
                    sx={{
                      borderRadius: "4px",
                      fontSize: "16px",
                      fontWeight: 600,
                      minWidth: "160px",
                    }}
                    key={index}
                    label={item}
                  />
                ))}
              </Tabs>
            </Grid>
          </Grid>

          {selectedTab == 0 && (
            <div className={classes.container}>
              <Grid
                item
                xs={12}
                style={{ textAlign: "right", alignItems: "right", marginBottom: 15 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonStyle}
                  onClick={() => setOpenSelQualDlg(true)}
                >
                  Select Qualified Applicants
                </Button>
              </Grid>

              <Box style={{ height: 372 }}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={columns}
                  rows={rows}
                  showCellRightBorder={true}
                  // hideFooter={true}
                  autoWidth={true}
                  getRowId={row => row.id}
                  getRowClassName={params => {
                    if (params.row.index + 1 <= noOfSeats) return "green";
                    if (params.row.index % 2 === 0) return "even";
                    else return "odd";
                  }}
                  //  autoHeight={true}
                  experimentalFeatures={{ newEditingApi: true }}
                  slots={{
                    footer: customFooter,
                  }}
                />
              </Box>
              {numExpandedRow === 1 && expandedRows.length > 0 && (
                <ApplicantsDetail
                  applicant={expandedRows[0]}
                  applySelectedQues={selQuesList => setQuesList(selQuesList)}
                  applyNewTotalAwardedScores={updatedData => sortApplicants(updatedData)}
                  initQuesList={quesList}
                />
              )}
              {numExpandedRow === 2 && expandedRows.length > 1 && (
                <ApplicantsOneOnOne
                  applicants={expandedRows}
                  applySelectedQues={selQuesList => setQuesList(selQuesList)}
                  applyNewTotalAwardedScores={updatedData => sortApplicants(updatedData)}
                  initQuesList={quesList}
                />
              )}

              {openSelQualDlg && (
                <SelectQualifiedApplicantsDialog
                  termUuid={termUuid}
                  applySelections={() => setOpenSelQualDlg(false)}
                  closeDialog={() => {
                    setOpenSelQualDlg(false);
                    getTermApplicants();
                  }}
                />
              )}

              {openApplicantInfoDlg && (
                <ApplicantInfoDialog
                  selectedApplicant={selectedApplicant}
                  selectedApplicantDateApplied={selectedApplicantDateApplied}
                  closeDialog={() => {
                    setOpenApplicantInfoDlg(false);
                  }}
                />
              )}

              {openEditApplicantFeedbackDialog && (
                <EditApplicantFeedbackDialog
                  selectedTermApplicant={selectedTermApplicant}
                  closeDialog={() => {
                    setOpenEditApplicantFeedbackDialog(false);
                    getTermApplicants();
                  }}
                />
              )}
            </div>
          )}

          {selectedTab == 1 && (
            <div className={classes.container}>
              {termInfo.notifyAll ? (
                <>
                  <Box style={{ height: 372 }}>
                    <DataGrid
                      className={classes.dataGridStyle}
                      columns={optColumns}
                      rows={optRows}
                      showCellRightBorder={true}
                      hideFooter={true}
                      autoHeight={true}
                      getRowId={row => row.index}
                      experimentalFeatures={{ newEditingApi: true }}
                    />
                  </Box>
                  {openEditTermApplicantNoteDialog && (
                    <EditTermApplicantNoteDialog
                      termApplicantId={currentApplicantData.termApplicantId}
                      closeDialog={() => {
                        setOpenEditTermApplicantNoteDialog(false);
                        getTermApplicants();
                      }}
                    />
                  )}
                </>
              ) : (
                <Typography variant="h2" style={{ color: "black", textAlign: "center" }}>
                  <p>The notification emails have not been sent yet.</p>
                  <p>
                    Go to tab "Applicants Qualifications" and initiate the process of
                    sending out the notification emails.
                  </p>
                </Typography>
              )}
            </div>
          )}

          {selectedTab == 2 && (
            <div className={classes.container}>
              {termInfo.notifyAll ? (
                <>
                  <Box style={{ height: 372 }}>
                    <Box style={{ paddingBottom: 12 }}>
                      <Typography
                        variant="h2"
                        style={{ color: "black", textAlign: "center" }}
                      >
                        Unqualified Applicants
                      </Typography>
                    </Box>

                    <DataGrid
                      className={classes.dataGridStyle}
                      columns={rejectedColumns}
                      rows={rejectedRows}
                      showCellRightBorder={true}
                      hideFooter={true}
                      autoHeight={true}
                      getRowId={row => row.index}
                      autoWidth={true}
                      experimentalFeatures={{ newEditingApi: true }}
                    />
                    {unQualApplicantsList.length !== 0 ? (
                      <Grid
                        item
                        xs={12}
                        style={{ textAlign: "left", alignItems: "left", marginTop: 20 }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonStyle}
                          onClick={handlePromoteClick}
                        >
                          Promote Unqualified Applicants
                        </Button>

                        {errorMsg.applicantSelection && (
                          <Box pt={1}>
                            <FormHelperText className={classes.errorStyle} error>
                              {errorMsg.applicantSelection}
                            </FormHelperText>
                          </Box>
                        )}
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Box>

                  {openSelUnQualDlg && (
                    <SelectUnQualifiedApplicantsDialog
                      termUuid={termUuid}
                      checkList={checkList}
                      applySelections={() => setOpenSelUnQualDlg(false)}
                      closeDialog={() => {
                        setOpenSelUnQualDlg(false);
                        getTermApplicants();
                      }}
                    />
                  )}
                </>
              ) : (
                <Typography variant="h2" style={{ color: "black", textAlign: "center" }}>
                  <p>
                    No adjustment should be done at this stage, because the notification
                    emails have not been sent yet.
                  </p>
                  <p>
                    Go to tab "Applicants Qualifications" and initiate the process of
                    sending out the notification emails.
                  </p>
                </Typography>
              )}
            </div>
          )}
        </div>
      </div>
    );
  else return;
}

export default ApplicantsBoard;
